export const formatPower = (power: string): string => {
  const num = parseFloat(power);
  if (!isFinite(num)) {
    return power;
  }
  const formatted = num.toFixed(2);
  return num > 0 ? `+${formatted}` : formatted;
};
